<template>
  <div id="header">
    <div class="left-container">
      <router-link :to="routeByRole" class="header-logo">
        <rp-logo />
      </router-link>
      <rp-search v-if="!fullscreen"></rp-search>
    </div>
    
    <div class="profile" v-if="authUser">
      <div class="profile-inner">
        <template v-if="!fullscreen">
          <div class="profile-details">
            <h2>{{authUser.profile.first_name}} {{authUser.profile.last_name}}</h2>
            <h4>{{authUser.email}}</h4>
            <h4>{{roleDisplayName}}</h4>
          </div>
          <div @click="toggleMenu" class="profile-icon">
            <rp-sprite :name="role"/>
          </div>
          <transition name="slide">
            <div class="profile-menu" v-if="profileMenuActive">
              <rp-button @click="logout" class="primary">Logout</rp-button>
            </div>
          </transition>
        </template>
        <template v-else>
          <!-- <div @click="$router.go(-1)"> -->
          <div @click="closeFullscreen()">
            <rp-sprite class="icon-fullscreen" name="fullscreen"/>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import RpLogo from 'raypro_ui/src/components/ui/Logo'
import Sprite from 'raypro_ui/src/components/ui/Sprite'
import Permissions from 'raypro_ui/src/components/Permissions'
import Button from 'raypro_ui/src/components/ui/inputs/Button'
import Search from 'raypro_ui/src/components/ui/Search'

import {mapGetters, mapActions} from 'vuex'

export default {
  components: {
    'rp-logo': RpLogo,
    'rp-permissions': Permissions,
    'rp-button': Button,
    'rp-search': Search,
    'rp-sprite': Sprite
  },

  props: {fullscreen: Boolean},

  data() {
    return {
      profileMenuActive: false,
      fromRoute: null,
      fallback: '/dashboard'
    }
  },

  computed: {
    ...mapGetters(['authUser', 'getAuthToken', 'lastUrl', 'isLicensed']),

    routeByRole() {
      if(this.role === 'Nurse') {
        return '/patients'
      }
      return '/'
    },

    role() {
      if(this.authUser) { return this.authUser ? this.authUser.roles[0].name : null }
    },

    roleDisplayName() {
      let roleName = (this.isLicensed)
        ? `Registered_${this.authUser.roles[0].name}`
        : this.authUser.roles[0].name

      const parts = roleName.split('_')
      if(parts.length === 0) { return '' }
      let result = parts[0].charAt(0).toUpperCase() + parts[0].slice(1)

      for(let i = 1; i < parts.length; i++) {
        result += ` ${parts[i].charAt(0).toUpperCase()}${parts[i].slice(1)}`
      }

      result = result.replace('Raypro', 'RayPRO')
      return result
    }
  },

  methods: {
    ...mapActions(['logoutUser']),

    toggleMenu() {
      this.profileMenuActive = !this.profileMenuActive
    },

    closeMenu() {
      this.profileMenuActive = false
    },

    logout() {
      this.logoutUser(this.getAuthToken)
        .then(() => {
          this.closeMenu()
          this.$root.$emit('logout')
          this.$router.push({name: 'Login'})
        })
        .catch(({response}) => {
          this.errors = response
        })
    },

    closeFullscreen() {
      if(this.lastUrl === '/') {
        this.$router.push({path: '/'})
      } else {
        this.$router.back()
      }
    },
  },

  filters: {
    userType(type) {
      const parts = type.split('_')

      if(parts.length === 0) { return '' }
      let result = parts[0].charAt(0).toUpperCase() + parts[0].slice(1)

      for(let i = 1; i < parts.length; i++) {
        result += ` ${parts[i].charAt(0).toUpperCase()}${parts[i].slice(1)}`
      }

      result = result.replace('Raypro', 'RayPRO')
      return result
    }
  }

}
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'
  @import '../stylesheets/helpers/mixins'

  #header
    padding: 2rem
    background-color: $color-panel-bg
    //box-shadow: 0 2px 7px 0 $color-shadow
    height: 75px
    display: flex
    align-items: center
    justify-content: space-between
    position: sticky
    top: 0
    z-index: 899

    @media screen and (max-width: 620px)
      height: auto
      align-items: flex-start

    .left-container
      display: flex
      align-items: center
      flex-grow: 1

      @media screen and (max-width: 620px)
        flex-direction: column
        align-items: flex-start
        margin-top: 10px

      .raypro-logo
        width: 130px
        height: 25px
        display: flex
        align-items: center
        justify-content: center
        margin: auto
        font-size: 2.8rem

        @media screen and (min-width: 620px)
          //border-right: 2px solid $color-grey-light
          margin: 0
          //width: 230px

      .rayproplus-logo
        height: 30px

    .profile
      text-align: right

      @include media($media-small)
        width: 60px
        display: inline-block

      @include media($media-medium)
        width: 45%

      .profile-inner
        display: flex
        align-items: center
        justify-content: center
        position: relative

        @include media($media-small)
          justify-content: flex-end

        .icon-fullscreen
          width: 30px
          height: 34px
          fill: #5B6C72

      .profile-details
        display: none
        color: $color-side-nav

        @include media($media-medium)
          display: block

        h2, h4
          margin: 0

        h2
          font-size: 14px

          @include media($media-small)
            font-size: 18px

        h4
          font-weight: $font-light
          color: $color-placeholder
          font-size: 12px
          text-align: right

      .profile-icon
        cursor: pointer
        display: flex
        align-items: center
        justify-content: center
        width: 45px
        padding: 10px
        height: 45px
        margin-left: 10px
        background-color: $color-primary
        border-radius: 50%
        fill: #fff
        .sprite
          height: 30px

  .profile-menu
    position: absolute
    top: 100%
    right: 0
    background-color: $color-panel-bg
    box-shadow: 0 0 4px $color-shadow
    padding: 0 20px
    margin-top: 10px
    border-radius: 5px
    z-index: 1

    .btn
      margin: 20px auto
</style>



// WEBPACK FOOTER //
// src/components/Header.vue